import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-select-card-button",
  templateUrl: "./select-card-button.component.html",
  styleUrls: ["./select-card-button.component.scss"],
  standalone: false,
})
export class SelectCardButtonComponent implements OnInit {
  @Input() defaultCard: string = "";
  constructor(private router: Router, private appService: AppService) {}

  ngOnInit() {}

  navigateToPaymentMethods() {
    this.appService.dispatchModal("CHECK_PAYMENT_MODAL", false);
    setTimeout(() => {
      this.router.navigate(["/particulier/configurations/payment-methods"]);
    }, 100);
  }
}
